import React from 'react';
const SelectOptions = ({options, state}) => {
  return (
    <>
      <option value=''> select . . . </option>
      {options.map((option) => (
        (option.state === state || state === 'end' )&& <option 
          key={option.id}
          value={option.id}
        >{option.name}</option>
      ))}
    </>
  )
}

export default SelectOptions;